import { message } from 'antd'
import Context from '../Context'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import authService from 'authService'

const authApp = process.env.REACT_APP_AUTH_URL

const manageRole = async ({ role, action }) => {
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: `/role/status/${role}/${action}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  return data
}

const useManageUSer = setPopOpen => {
  const {
    queryHandler: { data },
    states: { page },
    actions: { setDirtyBit, setPage }
  } = useContext(Context)

  const paginationInfo = get(data, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 7,
    totalPages: 1,
    totalRecords: 1
  })

  const { isLoading, isError, mutate } = useMutation({
    mutationKey: 'manage_role',
    mutationFn: manageRole,
    onSuccess: () => {
      const { totalRecords, currentPage, totalPages } = paginationInfo
      setPopOpen(false)

      if (
        currentPage > Math.ceil((totalRecords - 1) / 9) &&
        currentPage !== 1
      ) {
        setPage(page - 1)
      } else setDirtyBit(true)

      message.success({
        type: 'success',
        content: 'Acción realizada con exito'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = (role, action) => {
    mutate({ role, action })
  }

  return {
    isLoading,
    isError,
    onClick
  }
}

export default useManageUSer
